import {
  init as SentryInit,
  browserTracingIntegration,
  replayIntegration,
  replayCanvasIntegration,
  reactRouterV7BrowserTracingIntegration,
  captureMessage,
} from "@sentry/react";
import { useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from "react-router";
import { env } from "@env";
import { useEffect } from "react";

SentryInit({
  dsn: env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
  environment: env.VITE_APP_ENV,
  enabled: env.isDev ? false : true,
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", "https://api.dev.nautika.app", "https://dev.nautika.app"],
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
  integrations: [
    browserTracingIntegration(),
    replayIntegration(),
    replayCanvasIntegration(),
    reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
});

const originalConsoleError = console.error;
console.error = (...args) => {
  captureMessage(args.map((arg) => (typeof arg === "string" ? arg : JSON.stringify(arg, null, 2))).join(" "), "error");
  originalConsoleError(...args);
};
